import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { Box } from "@mui/material";

type Props = {
  isVerified: boolean;
};

export const VerificationIcon = ({ isVerified }: Props) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="flex-start"
    width="100%"
    height={20}
    pl={1}
  >
    {isVerified ? (
      <CheckOutlinedIcon color="success" />
    ) : (
      <ClearOutlinedIcon color="error" />
    )}
  </Box>
);
